import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { selectorArg1, selectorArg2 } from '../utils/selectors';
import { ConversationThreadEntityType } from '../../utils/apollo/graphqlSchema';

export const conversationThreadsSelector = (rootState: RootState) =>
  rootState.conversationThreads;

export const selectEntityConversationThreads = createSelector(
  conversationThreadsSelector,
  selectorArg1<ConversationThreadEntityType>(),
  selectorArg2<string>(),
  (state, type, id) => {
    if (!state.threads.length) {
      return [];
    }

    return state.threads.filter(
      (thread) => thread.entity.type === type && thread.entity.id === id,
    );
  },
);
